export class UnitOfMeasurement {
    Id: number;
    Name: string;
    WeightFactor: number;
    DimensionFactor: number; 
    WeightUoMName: string;
    DimensionUoMName: string;
    constructor() {}
}
